

if (!customElements.get('filter-range')) {
    class FilterRange extends HTMLElement {
      constructor() {
        super();
        
        this.minNumberInput = this.querySelector('#filter-range-number-min');
        this.maxNumberInput = this.querySelector('#filter-range-number-max');
        this.minSliderInput = this.querySelector('#filter-range-slider-min');
        this.maxSliderInput = this.querySelector('#filter-range-slider-max');
        this.hiddenCheckbox = this.querySelector('#filter-last-values');
        
        this.step = parseFloat(this.minSliderInput.step);
        this.allValues = this.dataset.allValues.split(',');
        this.minValue = Number(this.minNumberInput.min);
        this.maxValue = Number(this.maxNumberInput.max);
        this.timeout = null;
        this.addEventListener('input', this.handleInput.bind(this));
      }

  
      /**
       * Handles 'input' events on the price range component.
       * @param {object} evt - Event object.
       */
      handleInput(evt) {
        if (evt.detail !== undefined) {
          clearTimeout(this.timeout);
  
          this.timeout = setTimeout(() => {
            this.updateSliderInputs(evt);
            this.updateNumberInputs();
          }, 500);
        } else {
          this.updateSliderInputs(evt);
          this.updateNumberInputs();
        }
      }
  
      /**
       * Updates the value of the 'number' type inputs.
       */
      updateNumberInputs() {
        this.hiddenCheckbox.checked = false
        this.minNumberInput.value = this.minSliderInput.value !== this.minNumberInput.min
          ? this.minSliderInput.value : null;

        this.maxNumberInput.value = this.maxSliderInput.value !== this.maxNumberInput.max + this.step 
          ? this.maxSliderInput.value : null;

        const min = parseFloat(this.minNumberInput.value, this.step ) || 0;
        const max = parseFloat(this.maxNumberInput.value, this.step );
        const values = [];
        for (let i = 0; i < this.allValues.length; i++) {
          const value = parseFloat(this.allValues[i], this.step );
          if (value >= min && value <= max) {
            values.push(value);
          }
        }

        this.hiddenCheckbox.value = values.join(',');
        this.hiddenCheckbox.checked = true
      }
  
      /**
       * Updates the value of the 'range' type inputs.
       * @param {object} evt - Event object.
       */
      updateSliderInputs(evt) {
        const minValue = parseFloat(this.minNumberInput.value, this.step ) || 0;
        const maxValue = parseFloat(this.maxNumberInput.value, this.step );
        console.log(minValue, maxValue)
        if (minValue > maxValue - this.step ) {
          if (evt.target === this.minNumberInput) {
            this.maxSliderInput.value = minValue + this.step ;
  
            if (maxValue === this.maxValue) {
              this.minSliderInput.value = this.maxValue - this.step ;
            }
          } else {
            this.minSliderInput.value = maxValue - this.step ;
          }
        }
  
        if (maxValue < minValue + this.step ) {
          if (evt.target === this.maxNumberInput) {
            this.minSliderInput.value = maxValue - this.step ;
  
            if (minValue === this.minValue) {
              this.maxSliderInput.value = this.step ;
            }
          } else {
            this.maxSliderInput.value = minValue + this.step ;
          }
        }
  
        if (evt.target === this.minNumberInput) {

          this.minSliderInput.value = minValue || Number(this.minNumberInput.min);
        }
  
        if (evt.target === this.maxNumberInput) {
          this.maxSliderInput.value = maxValue || Number(this.maxNumberInput.max);
        }
      }
    }
  
    customElements.define('filter-range', FilterRange);
  }
  